import React, { Component } from 'react';
import LinkButton from '../LinkButton';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export class SupervisorMenu extends Component {
    static displayName = SupervisorMenu.name;

    constructor(props) {
        super(props);
        this.state = { data: [], loading: true };
        this.history = props.history;
    }

    componentDidMount() {
    }
    goto(page) {
        this.history.push(page);
    }

    render() {

        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h4>Supervisor Menu</h4></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('../MainMenu'); }} >
                            Back
                        </button>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <LinkButton className="btn btn-success col-12 mb-2" to="UpdateLocationCharge" >Update Charge Skeleton</LinkButton>
                            <LinkButton className="btn btn-success col-12 mb-2" to="../ToteApproval" >Approve Totes Inwards</LinkButton>

                        </Col>
                    </Row>

                </Container>
            </div>
        );

    }


}
